<ion-content>
  <div class="file-upload-block">
    <div class="header">
      <span class="upload-title">{{ uploadTitle }}</span> <!-- Dynamic Title -->
      <img class="close-icon" tooltip="{{'Close' | translate }}" alt="" placement="bottom" 
        tabindex="0" role="button"
        (click)="closeModal()" (keydown.enter)="closeModal()"
        src="assets/icon/cancel.svg">
    </div>
    <div class="sub-header">
      <span [ngClass]="{'hidden-sub-header': !showSubHeader}">
        {{ subHeader }}
      </span>
      <div *ngIf="!hideDownloadLink">
        <a *ngIf="showDownloadLink && !sampleDownload" [href]="downloadLinkUrl" class="download-link" target="_blank">
          {{ downloadLinkText }}
        </a>
        <span class="download-link-text" tabindex="0" role="button"
          *ngIf="!showDownloadLink && sampleDownload" 
          (click)="onClickDownloadLink()"
          (keydown.enter)="onClickDownloadLink()">{{ downloadLinkText }}</span>
      </div>
    </div>
    <div class="upload-file-container">
      <div class="upload-box" tabindex="0" role="button"
        (click)="triggerFileInput()" (keydown.enter)="triggerFileInput()">
        <input #fileInput type="file" [accept]="acceptTypes"  (change)="onFileSelected($event)" hidden />
        <div class="upload-placeholder">
          <div class="upload-icon">+</div>
          <p>{{ dragDropText }}</p>
        </div>
      </div>

      <!-- File Preview -->
      <div class="file-preview" [ngClass]="{'hidden': !fileName}">
        <div class="file-details">
          <span class="file-icon">
            <img src="assets/icon/clip.svg" alt="">
          </span>
          <span class="file-name">{{ fileName }}</span>
        </div>

        <!-- Progress Bar -->
        <div class="progress-bar-container">
          <div class="progress-bar" 
               [style.width]="uploadProgress + '%'"
               [ngClass]="{'error': isErrorOccurred, 'success': !isErrorOccurred && isFileUploaded}">
          </div>
        </div>
      </div>

    </div>
    <!-- Done Button -->
    <div class="actions">
      <ion-button class="app-btn cancel-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
        {{ 'Cancel' | translate }}
      </ion-button>
      <ion-button [disabled]="!isFileUploaded" class="app-btn" shape="round" fill="outline" color="primary" (click)="onDone()">
        {{doneButtonText}}
      </ion-button>
    </div>
  </div>
</ion-content>